import React from 'react';
import Markdown from 'react-markdown';
import { WidgetChartConfig } from '../types';
import styles from './ChartText.module.scss';

interface ChartTextProps {
  config: WidgetChartConfig;
}

export const ChartText: React.FC<ChartTextProps> = ({ config }) => {
  const { content = '', backgroundColor, textColor } = config.textConfig ?? {};

  return (
    <div
      className={styles.root}
      style={{
        ...(backgroundColor ? { backgroundColor } : {}),
        ...(textColor ? { color: textColor } : {}),
      }}
    >
      {content ? (
        <div className={styles.markdown}>
          <Markdown>{content}</Markdown>
        </div>
      ) : (
        <p className={styles.empty}>No content yet. Click Edit to add text.</p>
      )}
    </div>
  );
};
